import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { MatDialogModule } from '@angular/material';
import { Title } from '@angular/platform-browser';
import { MomentModule } from 'angular2-moment';
import { SharedModule } from '../shared/shared.module';
import { UserUpdateProfileButtonComponent } from '../users/user-update-profile-button/user-update-profile-button';
import { AuthStateComponent } from './auth-state/auth-state.component';
import { AuthService } from './auth.service';
import { EnvService } from './env.service';
import { HttpService } from './http.service';
import { NavService } from './nav.service';
import { NavbarComponent } from './navbar/navbar.component';
import { UsersModule } from "../users/users.module";

@NgModule({
  imports: [
    SharedModule,
    MomentModule,
    MatDialogModule,
    UsersModule
  ],
  declarations: [
    NavbarComponent,
    AuthStateComponent
    // UserUpdateProfileButtonComponent
  ],
  exports: [
    NavbarComponent,
  ],
  providers: [
    EnvService,
    AuthService,
    HttpService,
    NavService,
    Title
  ],
})
export class CoreModule {
  constructor (@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error(
        'CoreModule is already loaded. Import it in the AppModule only');
    }
  }

  static forRoot(): ModuleWithProviders {
    return {
      ngModule: CoreModule
    };
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/core/core.module.ts